import { render, staticRenderFns } from "./qualityAccidentReport.vue?vue&type=template&id=17c8bd4f&scoped=true"
import script from "./qualityAccidentReport.vue?vue&type=script&lang=js"
export * from "./qualityAccidentReport.vue?vue&type=script&lang=js"
import style0 from "./qualityAccidentReport.vue?vue&type=style&index=0&id=17c8bd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8bd4f",
  null
  
)

export default component.exports